import { useEffect, useState } from 'react';
import { message } from 'antd';
import useTrans from '@/hooks/useTrans';
import { useRouter } from 'next/router';
import BreadcrumbComponent from '../components/Other/BreadCrumbComponent';
import Device from '@/components/Device';
import Slider from 'react-slick';
import MetaSeo from '@/components/MetaSeo';

/* eslint-disable jsx-quotes */
const Priority = () => {
  const trans = useTrans();
  const { locale } = useRouter();

  const [messageApi, contextHolder] = message.useMessage();
  const [isLoading, setIsLoading] = useState(false);

  const listLevel = [
    {
      name: 'Premium',
      icon: '/assets/img/priority/level-1.png',
    },
    {
      name: 'Privilege',
      icon: '/assets/img/priority/level-2.png',
    },
    {
      name: 'Diamond Elite',
      icon: '/assets/img/priority/level-3.png',
    },
  ];

  const listPrioritize = [...Array(4)].map((e, i) => ({
    title: trans.priority[`solution_item_${i + 1}_title`],
    content: trans.priority[`solution_item_${i + 1}_description`],
  }));

  const listQuestion = [...Array(10)].map((e, i) => ({
    title: trans.priority[`question_item_${i + 1}_title`],
    content: trans.priority[`question_item_${i + 1}_description`],
  }));

  const validateEmail = email => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = phone => {
    const phoneRegex = /^0\d{9}$/;
    return phoneRegex.test(phone);
  };

  const validateRequiredField = field => {
    return field.trim() !== '';
  };

  const isMobileDevice = () => {
    return /Mobi|Android/i.test(navigator.userAgent);
  };

  const success = () => {
    try {
      isMobileDevice()
        ? messageApi.open({
            type: 'success',
            content: trans.priority.sucess_form, // mobile là cái này
          })
        :       message.success(trans.priority.sucess_form); // máy tính là cái này
    } catch (error) {
      console.log('run to error==========================>', error);
      message.success(trans.priority.sucess_form);
    }
  };

  let settingNews = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    customPaging: () => {
      return <span></span>;
    },
    nextArrow: (
      <div className="controls_s">
        <img src="/assets/img/priority/outline_arrow_next.svg" alt="" />
      </div>
    ),
    prevArrow: (
      <div className="controls_s">
        <img src="/assets/img/priority/outline_arrow_prev.svg" alt="" />
      </div>
    ),
    responsive: [
      {
        breakpoint: 725,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const form = document.getElementById('form_submit');

    const handleSubmit = event => {
      event.preventDefault();

      const formData = new FormData(form);
      const name = formData.get('Name');
      const email = formData.get('Email');
      const phone = formData.get('Phone');
      const job = formData.get('Job');

      if (!validateRequiredField(name)) {
        message.error(`Họ tên ${trans.priority.required}`);
        return;
      }

      if (!validateRequiredField(job)) {
        message.error(`Công việc ${trans.priority.required}`);
        return;
      }

      if (!validateEmail(email)) {
        message.error(trans.priority.invalid_email);
        return;
      }

      if (!validatePhone(phone)) {
        message.error(trans.priority.invalid_phone);
        return;
      }

      success();
      setIsLoading(true);
      isMobileDevice() && form.reset();
      fetch(form.action, {
        method: 'POST',
        body: formData,
      })
        .then(response => response.text())
        .then(data => {
          console.log('data======================>', data);
          !isMobileDevice() && ( success(), form.reset());
          setIsLoading(false);
        })
        .catch(error => {
          console.error('Error:', error);
          setIsLoading(false);
        });
    };

    if (form) {
      form.addEventListener('submit', handleSubmit);
    }

    // Cleanup the event listener on component unmount
    return () => {
      if (form) {
        form.removeEventListener('submit', handleSubmit);
      }
    };
  }, []);

  useEffect(() => {
    if (window) {
      console.log(window, '=============window================');

      // formSubmit();
      setTimeout(() => {
        const titleQuestions = document.querySelectorAll(
          '.question_list-item_title',
        );
        const contentQuestions = document.querySelectorAll(
          '.question_list-item_content',
        );

        if (titleQuestions && contentQuestions) {
          titleQuestions.forEach(function(titleQuestion, index) {
            titleQuestion.onclick = function() {
              this.classList.toggle('open');
              contentQuestions[index].classList.toggle('open');
            };
          });
        }
      }, 1000);
    }
  }, []);

  const dataSeo = {
    title: "HanaGold Priority",
    description: "Dịch vụ Khách hàng Ưu tiên dành riêng các Khách hàng Cá nhân cao cấp của Công ty Cổ Phần Vàng Bạc Đá Quý HanaGold.",
    image: "https://api.hanagold.vn/media-new/1727082542875-hanagoldprioritypng.png",
    url: 'https://hanagold.vn/priority'
  };

  return (
    <>
    <MetaSeo {...dataSeo}/>
    <main className="priority__container">
      {contextHolder}
      <div className="priority_breadcrumb_container">
        <BreadcrumbComponent title="HanaGold Priority" url='priority'/>
      </div>
      <section className="banner">
        <img src="/assets/img/priority/Banner.png" alt="" className="use-pc" />
        <img
          src="/assets/img/priority/banner-sp.png"
          alt=""
          className="use-sp"
        />
        <div className="banner_content banner_content_priority">
          <div className="container">
            <div className="banner_content_text">
              <h6 className="banner_sub-title">
                {trans.priority.baner_subtitle}
              </h6>
              <h2 className="banner_title">{trans.priority.baner_title}</h2>
            </div>
          </div>
        </div>
      </section>
      <section className="discover">
        <div className="container">
          <div className="discover_text" data-aos="fade-right">
            <h6 className="discover_text_sub-title">
              {trans.priority.discover_subtitle}
            </h6>
            <h2 className="discover_text_title">
              {trans.priority.discover_title_line_1}
              <br />
              {trans.priority.discover_title_line_2}
            </h2>
            <p className="discover_text_des">
              {trans.priority.discover_description}
            </p>
          </div>
          <div className="discover_item" data-aos="fade-left">
            <div className="discover_item-left">
              <img
                src="/assets/img/priority/discover-1.png"
                alt=""
                className="use-pc"
              />
              <img
                src="/assets/img/priority/discover-1-sp.png"
                alt=""
                className="use-sp"
              />
              <div className="discover_item-left_text">
                <h6>{trans.priority.discover_item_1_title}</h6>
                <p>{trans.priority.discover_item_1_description}</p>
              </div>
            </div>
            <div className="discover_item-right">
              <div className="discover_item-right_item">
                <img
                  src="/assets/img/priority/discover-2.png"
                  alt=""
                  className="use-pc"
                />
                <img
                  src="/assets/img/priority/discover-2-sp.png"
                  alt=""
                  className="use-sp"
                />
                <div className="discover_item-right_item_text">
                  <h6>{trans.priority.discover_item_2_title}</h6>
                  <p>{trans.priority.discover_item_2_description}</p>
                </div>
              </div>
              <div className="discover_item-right_item">
                <img
                  src="/assets/img/priority/discover-3.png"
                  alt=""
                  className="use-pc"
                />
                <img
                  src="/assets/img/priority/discover-3-sp.png"
                  alt=""
                  className="use-sp"
                />
                <div className="discover_item-right_item_text">
                  <h6>{trans.priority.discover_item_3_title}</h6>
                  <p>{trans.priority.discover_item_3_description}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="level">
        <div className="container" data-aos="fade-down">
          <h2 className="level_title">{trans.priority.level_title}</h2>
          <p className="level_des">{trans.priority.level_description}</p>
          <div className="level_content">
            {listLevel.map((e, i) => (
              <div className="level_content_item" key={i}>
                <div className="level_content_item-bg"></div>
                <div className="level_content_item-top">
                  <p>{`0${i + 1}`}</p>
                  <img src={e.icon} alt="" />
                </div>
                <div className="level_content_item-bot">
                  <p>{trans.priority.level}</p>
                  <h6>{e.name}</h6>
                </div>
              </div>
            ))}
          </div>
          <div className="swiper level-slider">
            <Slider {...settingNews}>
              {listLevel.map((e, i) => {
                return (
                  <div key={i}>
                    <div className="level_content_item">
                      <div className={`level_content_item-bg_${i + 1}`}></div>
                      <div className="level_content_item-top">
                        <p>{`0${i + 1}`}</p>
                        <img
                          src={`/assets/img/priority/level-${i + 1}.png`}
                          alt=""
                        />
                      </div>
                      <div className="level_content_item-bot">
                        <p> {trans.priority.level_label}</p>
                        <h6>{e.name}</h6>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
        </div>
      </section>
      <section className="solution">
        <div className="container" data-aos="fade-down">
          <div className="solution_top">
            <h2 className="solution_title">{trans.priority.solution_title}</h2>
            <Device>
              {({ isMobile }) => (
                <>
                  {!isMobile && (
                    <>
                      <div className="solution_title-image">
                        <img
                          src="../assets/img/priority/hanagold_priority_solution.svg"
                          alt="hanagold_priority"
                        />
                      </div>
                    </>
                  )}
                  {isMobile && (
                    <>
                      <div className="">
                        <img
                          src="../assets/img/priority/hanagold_priority_solution_mb.svg"
                          alt="hanagold_priority"
                        />
                      </div>
                    </>
                  )}
                </>
              )}
            </Device>
          </div>
          <Device>
            {({ isMobile }) => (
              <>
                {!isMobile && (
                  <>
                    <div className="solution_list">
                      <div className="solution_block">
                        {listPrioritize.slice(0, 2).map((e, i) => (
                          <div className="solution_list-item" key={i}>
                            <h6>{e.title}</h6>
                            <p>{e.content}</p>
                          </div>
                        ))}
                      </div>
                      <div className="solution_block">
                        {listPrioritize.slice(2, 4).map((e, i) => (
                          <div className="solution_list-item" key={i}>
                            <h6>{e.title}</h6>
                            <p>{e.content}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                )}
                {isMobile && (
                  <>
                    <div className="solution_list">
                      {listPrioritize.map((e, i) => (
                        <div className="solution_list-item" key={i}>
                          <h6>{e.title}</h6>
                          <p>{e.content}</p>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </>
            )}
          </Device>
        </div>
      </section>
      <section className="question">
        <div className="container" data-aos="fade-down">
          <h2 className="question_title"> {trans.priority.question_title}</h2>
          <Device>
            {({ isMobile }) => (
              <>
                {!isMobile && (
                  <>
                    <div className="question_list_block">
                      <div className="question_list">
                        {listQuestion.slice(0, 5).map((e, i) => (
                          <div className="question_list-item" key={i}>
                            <div className="question_list-item_title">
                              <p>
                                {i + 1}. {e.title}
                              </p>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                className="plus"
                              >
                                <path
                                  d="M12.8889 4.88889C12.8889 4.65314 12.7952 4.42705 12.6285 4.26035C12.4618 4.09365 12.2357 4 12 4C11.7643 4 11.5382 4.09365 11.3715 4.26035C11.2048 4.42705 11.1111 4.65314 11.1111 4.88889V11.1111H4.88889C4.65314 11.1111 4.42705 11.2048 4.26035 11.3715C4.09365 11.5382 4 11.7643 4 12C4 12.2357 4.09365 12.4618 4.26035 12.6285C4.42705 12.7952 4.65314 12.8889 4.88889 12.8889H11.1111V19.1111C11.1111 19.3469 11.2048 19.573 11.3715 19.7397C11.5382 19.9064 11.7643 20 12 20C12.2357 20 12.4618 19.9064 12.6285 19.7397C12.7952 19.573 12.8889 19.3469 12.8889 19.1111V12.8889H19.1111C19.3469 12.8889 19.573 12.7952 19.7397 12.6285C19.9064 12.4618 20 12.2357 20 12C20 11.7643 19.9064 11.5382 19.7397 11.3715C19.573 11.2048 19.3469 11.1111 19.1111 11.1111H12.8889V4.88889Z"
                                  fill="#F2F2F2"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                className="minus"
                              >
                                <path
                                  d="M12.8889 11C12.5938 11 12.0889 11 12 11C11.7643 11 12.275 11 12 11C11.7643 11 11.8063 11 11.1111 11H4.88889C4.65314 11 4.42705 11.0996 4.26035 11.2769C4.09365 11.4542 4 11.7479 4 11.9986C4 12.2494 4.09365 12.4845 4.26035 12.6618C4.42705 12.8391 4.65314 12.9973 4.88889 12.9973H11.1111C11.1111 12.9973 11.7643 12.9973 12 12.9973C12.2357 12.9973 12.95 12.9972 12.95 12.9972H19.1111C19.3469 12.9972 19.573 12.8468 19.7397 12.6695C19.9064 12.4922 20 12.1961 20 11.9454C20 11.6947 19.9064 11.4542 19.7397 11.2769C19.573 11.0996 19.3469 11 19.1111 11L12.8889 11Z"
                                  fill="#F2F2F2"
                                />
                              </svg>
                            </div>
                            <div className="question_list-item_content">
                              {e.content}
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="question_list">
                        {listQuestion.slice(5, 10).map((e, i) => (
                          <div className="question_list-item" key={i}>
                            <div className="question_list-item_title">
                              <p>
                                {i + 6}. {e.title}
                              </p>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                className="plus"
                              >
                                <path
                                  d="M12.8889 4.88889C12.8889 4.65314 12.7952 4.42705 12.6285 4.26035C12.4618 4.09365 12.2357 4 12 4C11.7643 4 11.5382 4.09365 11.3715 4.26035C11.2048 4.42705 11.1111 4.65314 11.1111 4.88889V11.1111H4.88889C4.65314 11.1111 4.42705 11.2048 4.26035 11.3715C4.09365 11.5382 4 11.7643 4 12C4 12.2357 4.09365 12.4618 4.26035 12.6285C4.42705 12.7952 4.65314 12.8889 4.88889 12.8889H11.1111V19.1111C11.1111 19.3469 11.2048 19.573 11.3715 19.7397C11.5382 19.9064 11.7643 20 12 20C12.2357 20 12.4618 19.9064 12.6285 19.7397C12.7952 19.573 12.8889 19.3469 12.8889 19.1111V12.8889H19.1111C19.3469 12.8889 19.573 12.7952 19.7397 12.6285C19.9064 12.4618 20 12.2357 20 12C20 11.7643 19.9064 11.5382 19.7397 11.3715C19.573 11.2048 19.3469 11.1111 19.1111 11.1111H12.8889V4.88889Z"
                                  fill="#F2F2F2"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                className="minus"
                              >
                                <path
                                  d="M12.8889 11C12.5938 11 12.0889 11 12 11C11.7643 11 12.275 11 12 11C11.7643 11 11.8063 11 11.1111 11H4.88889C4.65314 11 4.42705 11.0996 4.26035 11.2769C4.09365 11.4542 4 11.7479 4 11.9986C4 12.2494 4.09365 12.4845 4.26035 12.6618C4.42705 12.8391 4.65314 12.9973 4.88889 12.9973H11.1111C11.1111 12.9973 11.7643 12.9973 12 12.9973C12.2357 12.9973 12.95 12.9972 12.95 12.9972H19.1111C19.3469 12.9972 19.573 12.8468 19.7397 12.6695C19.9064 12.4922 20 12.1961 20 11.9454C20 11.6947 19.9064 11.4542 19.7397 11.2769C19.573 11.0996 19.3469 11 19.1111 11L12.8889 11Z"
                                  fill="#F2F2F2"
                                />
                              </svg>
                            </div>
                            <div className="question_list-item_content">
                              {e.content}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                )}
                {isMobile && (
                  <>
                    <div className="question_list">
                      {listQuestion.map((e, i) => (
                        <div className="question_list-item" key={i}>
                          <div className="question_list-item_title">
                            <p>
                              {i + 1}. {e.title}
                            </p>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              className="plus"
                            >
                              <path
                                d="M12.8889 4.88889C12.8889 4.65314 12.7952 4.42705 12.6285 4.26035C12.4618 4.09365 12.2357 4 12 4C11.7643 4 11.5382 4.09365 11.3715 4.26035C11.2048 4.42705 11.1111 4.65314 11.1111 4.88889V11.1111H4.88889C4.65314 11.1111 4.42705 11.2048 4.26035 11.3715C4.09365 11.5382 4 11.7643 4 12C4 12.2357 4.09365 12.4618 4.26035 12.6285C4.42705 12.7952 4.65314 12.8889 4.88889 12.8889H11.1111V19.1111C11.1111 19.3469 11.2048 19.573 11.3715 19.7397C11.5382 19.9064 11.7643 20 12 20C12.2357 20 12.4618 19.9064 12.6285 19.7397C12.7952 19.573 12.8889 19.3469 12.8889 19.1111V12.8889H19.1111C19.3469 12.8889 19.573 12.7952 19.7397 12.6285C19.9064 12.4618 20 12.2357 20 12C20 11.7643 19.9064 11.5382 19.7397 11.3715C19.573 11.2048 19.3469 11.1111 19.1111 11.1111H12.8889V4.88889Z"
                                fill="#F2F2F2"
                              />
                            </svg>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              className="minus"
                            >
                              <path
                                d="M12.8889 11C12.5938 11 12.0889 11 12 11C11.7643 11 12.275 11 12 11C11.7643 11 11.8063 11 11.1111 11H4.88889C4.65314 11 4.42705 11.0996 4.26035 11.2769C4.09365 11.4542 4 11.7479 4 11.9986C4 12.2494 4.09365 12.4845 4.26035 12.6618C4.42705 12.8391 4.65314 12.9973 4.88889 12.9973H11.1111C11.1111 12.9973 11.7643 12.9973 12 12.9973C12.2357 12.9973 12.95 12.9972 12.95 12.9972H19.1111C19.3469 12.9972 19.573 12.8468 19.7397 12.6695C19.9064 12.4922 20 12.1961 20 11.9454C20 11.6947 19.9064 11.4542 19.7397 11.2769C19.573 11.0996 19.3469 11 19.1111 11L12.8889 11Z"
                                fill="#F2F2F2"
                              />
                            </svg>
                          </div>
                          <div className="question_list-item_content">
                            {e.content}
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </>
            )}
          </Device>
        </div>
      </section>
      <section
        className="form"
        style={{
          backgroundImage: `url(/assets/img/priority/bg_form_${
            locale === 'en' ? 'en' : 'vi'
          }.png)`,
        }}
      >
        <img
          data-aos="fade-right"
          src={`/assets/img/priority/img-form-sp-${
            locale === 'en' ? 'en' : 'vi'
          }.png`}
          alt=""
        />
        <div className="container_form">
          <form
            data-aos="fade-left"
            id="form_submit"
            method="POST"
            action={process.env.NEXT_PUBLIC_URL_SHEET}
          >
            <div className="form_text">
              <h6 className="form_sub-title">
                {' '}
                {trans.priority.form_subtitle}
              </h6>
              <h2 className="form_title"> {trans.priority.form_title}</h2>
            </div>
            <div className="form_input">
              <input
                type="text"
                name="Name"
                placeholder={trans.priority.form_name}
                required
              />
              <input
                type="email"
                name="Email"
                placeholder={trans.priority.form_email}
                required
              />
              <input
                type="number"
                name="Phone"
                placeholder={trans.priority.form_phone}
                required
              />
              <input
                type="text"
                name="Job"
                placeholder={trans.priority.form_work}
              />
              <button
                disabled={isLoading}
                type="submit"
                className="btn__submit__form"
              >
                {trans.priority.form_btn}
              </button>
            </div>
          </form>
        </div>
      </section>
    </main>
    </>
  );
};

export default Priority;
